














import { Component, Prop, Vue } from 'vue-property-decorator';
import { eventBus } from '@/constants/bus';

@Component
export default class Fleche extends Vue {
	// 'left' ou 'right'
	@Prop()
	direction!: string;

	private intervalId!: any;
	private xScrollStart: boolean = true;
	private xScrollEnd: boolean = false;

	private flecheDown(): void {
		eventBus.$emit(
			this.$store.getters.getActiveGrandePeriodeIndex + 'flecheMouseDown',
			this.direction
		);
	}

	public onMouseDown(): void {
		this.intervalId = setInterval(this.flecheDown, 100);
	}

	public onMouseUp(): void {
		clearInterval(this.intervalId);
	}

	public get showFleche(): boolean {
		if (this.direction === 'left') {
			if (
				this.$store.getters.getIsFirstGrandePeriode &&
				this.xScrollStart
			) {
				clearInterval(this.intervalId);
				return false;
			}
		} else {
			if (this.$store.getters.getIsLastGrandePeriode && this.xScrollEnd) {
				clearInterval(this.intervalId);
				return false;
			}
		}

		return true;
	}

	get imgUrl() {
		return require('@/assets/img/navigate.svg');
	}

	protected created(): void {
		eventBus.$on('xScrollStart', (value: boolean) => {
			this.xScrollStart = value;
		});

		eventBus.$on('xScrollEnd', (value: boolean) => {
			this.xScrollEnd = value;
		});
	}
}
